import React, { type FC, useCallback, useContext } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import ChangesIcon from '@atlaskit/icon/core/changes';
import { IconButton } from '@atlaskit/button/new';
import Tooltip from '@atlaskit/tooltip';

import { ExperienceTrackerContext } from '@confluence/experience-tracker/entry-points/component';
import { CONTENT_OWNERSHIP_DIALOG_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName';

const i18n = defineMessages({
	changeOwner: {
		id: 'content-ownership.content-owner-item.change-owner',
		defaultMessage: 'Change owner',
		description: 'An icon label within a button used to change the owner of a page',
	},
});

type ChangeContentOwnerButtonProps = {
	onClick: () => void;
	analyticsContext?: Record<string, any>;
};

export const ChangeContentOwnerButton: FC<ChangeContentOwnerButtonProps> = ({
	onClick,
	analyticsContext,
}) => {
	const { formatMessage } = useIntl();
	const experienceTracker = useContext(ExperienceTrackerContext);

	const handleClick = useCallback(() => {
		experienceTracker.start({
			name: CONTENT_OWNERSHIP_DIALOG_EXPERIENCE,
		});
		onClick();
	}, [onClick, experienceTracker]);

	return (
		<Tooltip content={formatMessage(i18n.changeOwner)}>
			<IconButton
				appearance="subtle"
				icon={ChangesIcon}
				label={formatMessage(i18n.changeOwner)}
				onClick={handleClick}
				analyticsContext={analyticsContext}
				testId="changeOwnerButton"
			/>
		</Tooltip>
	);
};
